import React from 'react';
import { TouchTargetProps } from 'apps/sigma2-ui/src/components/ui/TouchTarget';
import { TertiaryButton } from 'apps/sigma2-ui/src/components/TertiaryButton';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';

type EditRubricSaveButtonProps = Pick<TouchTargetProps, 'behavior'> & {
  disabled: boolean;
};

const EditRubricSaveButtonIcon: React.FC<SvgProps> = (props) => {
  const strokeColor = toSvgColor('currentColor', props);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M3.33594 8.66675L6.0026 11.3334L12.6693 4.66675"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const EditRubricSaveButton: React.FC<EditRubricSaveButtonProps> = ({
  behavior,
  disabled,
}) => {
  const language = useLanguage();
  return (
    <TertiaryButton
      label={language.editRubricSaveButtonLabel()}
      icon={<EditRubricSaveButtonIcon />}
      behavior={behavior}
      disabled={disabled}
      className="rounded border-[1.5px] border-royal-900 pl-4 pr-6 py-2"
    />
  );
};
